/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Keyword_Optimizer_Generate_Cta_TitleInputs */

const en_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} keywords missing from your resume`)
};

const de_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Keywords fehlen in deinem Lebenslauf`)
};

const fr_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mots-clés manquent dans votre CV`)
};

const es_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faltan ${i?.count} palabras clave en tu CV`)
};

const it_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parole chiave mancanti nel tuo CV`)
};

const nl_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} zoekwoorden ontbreken in je CV`)
};

const pl_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W Twoim CV brakuje ${i?.count} słów kluczowych`)
};

const fi_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} avainsanaa puuttuu ansioluettelostasi`)
};

const da_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nøgleord mangler i dit CV`)
};

const sv_keyword_optimizer_generate_cta_title = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nyckelord saknas i ditt CV`)
};

/**
* | output |
* | --- |
* | "{count} keywords missing from your resume" |
*
* @param {Keyword_Optimizer_Generate_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_title = /** @type {((inputs: Keyword_Optimizer_Generate_Cta_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_title(inputs)
	return en_keyword_optimizer_generate_cta_title(inputs)
});